/* global zaraz */
import { apiPostData } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/apiService';
import axios from 'axios';
import { toast } from 'react-toastify';
import {
    getBuildVersion,
} from '@PROJECT_ROOT/assets/responsive-frontend/js/services/utils';

export const handleAxiosError = (error) => {
    const axiosCustomErrors = JSON.parse(document.getElementById('mainWrapper')?.getAttribute('data-axios'));
    if (axios.isAxiosError(error)) {
        switch (error.code) {
            case 'ERR_NETWORK':
                toast.error(axiosCustomErrors?.connectionError);
                break;
            case 'ERR_BAD_REQUEST':
                if (error.config?.method === 'post' || error.config?.method === 'options') {
                    toast.info(axiosCustomErrors?.unavailableText);
                }
                break;
            default:
                break;
        }
    }
};

const isBot = (userAgent) => {
    const botPatterns = [
        /Googlebot.*www\.google\.com\/bot\.html/,
        /bingbot.*www\.bing\.com\/bingbot\.htm/,
        /YandexMobileBot\/3\.0.*yandex\.com\/bots/,
        /AdsBot-Google-Mobile.*www\.google\.com\/mobile\/adsbot\.html/,
        /Google-Read-Aloud.*support\.google\.com\/webmasters\/answer\/1061943/,
        /AdsBot-Google.*www\.google\.com\/adsbot\.html/,
        /YandexBot\/3\.0.*yandex\.com\/bots/,
        /Baiduspider-render\/2\.0.*www\.baidu\.com\/search\/spider\.html/,
        /Applebot\/0\.1;.*http:\/\/www\.apple\.com\/go\/applebot/,
        /meta-externalagent\/1\.1.*developers\.facebook\.com\/docs\/sharing\/webmasters\/crawler/,
        /PingdomPageSpeed\/1\.0.*pingbot\/2\.0.*pingdom\.com/,
    ];
    return botPatterns.some((pattern) => pattern.test(userAgent));
};

const reportLog = (errorData, debugOnly) => {
    // TODO: Potrebno odrediti koje sve informacije želimo slati kad dođe do error-a.
    if (axios.isCancel(errorData)) return;
    handleAxiosError(errorData);
    const postPath = debugOnly ? 'log/debug' : 'log/error';
    const browserInfo = {
        userAgent: window.navigator.userAgent,
        language: window.navigator.language,
        platform: window.navigator.platform,
        cookiesEnabled: window.navigator.cookieEnabled,
        online: window.navigator.onLine,
        screenResolution: `${window.screen.width}x${window.screen.height}`,
        colorDepth: window.screen.colorDepth,
    };
    if (isBot(browserInfo.userAgent)) {
        return;
    }
    const errorInfo = {
        message: errorData.message || 'Nepoznato',
        stack: errorData.stack || 'Nepoznato',
        name: errorData.name || 'Nepoznato',
        fileName: errorData.fileName || 'Nepoznato',
        lineNumber: errorData.lineNumber || 'Nepoznato',
        columnNumber: errorData.columnNumber || 'Nepoznato',
        cause: errorData.cause || 'Nepoznato',
        code: errorData.code || 'Nepoznato',
        details: errorData.details || 'Nepoznato',
        timestamp: new Date().toLocaleString('en-GB', { timeZone: 'Europe/Zagreb' }),
    };
    const preparedData = {
        errorName: errorData.code || errorData.name || 'ERROR NAME NIJE ZABILJEŽEN',
        errorOnPage: encodeURI(window.location.href) || 'Nepoznato',
        referrerPageToPageOnWhichErrorOcured: encodeURI(document.referrer) || 'Nepoznato',
        buildVersion: getBuildVersion(),
        errorInfo,
        errorData,
        browserInfo,
    };
    const completedData = {
        logText: JSON.stringify(preparedData, null, 4),
    };
    apiPostData(postPath, completedData)
        .then(() => {
            // TODO: Dok smo na developmentu
        })
        .catch(() => {
        });
};

export const reportError = (errorData) => {
    reportLog(errorData, false);
};

export const reportDebug = (debugData) => {
    reportLog(debugData, true);
};

export const reportErrorSSR = (errorData) => {
    const postPath = 'log/error';
    const errorInfo = {
        message: errorData?.message || 'Nepoznato',
        stack: errorData?.stack || 'Nepoznato',
        name: errorData?.name || 'Nepoznato',
        fileName: errorData?.fileName || 'Nepoznato',
        lineNumber: errorData?.lineNumber || 'Nepoznato',
        columnNumber: errorData?.columnNumber || 'Nepoznato',
        cause: errorData?.cause || 'Nepoznato',
        code: errorData?.code || 'Nepoznato',
        details: errorData?.details || 'Nepoznato',
        timestamp: new Date().toLocaleString('en-GB', { timeZone: 'Europe/Zagreb' }),
    };
    const preparedData = {
        errorName: errorData?.code || errorData?.name || 'ERROR NAME NIJE ZABILJEŽEN',
        errorOnPage: 'SSR ERROR',
        customMessage: errorData?.customMessage || 'Nepoznato',
        errorInfo,
        errorData: JSON.stringify(errorData),
    };
    const completedData = {
        logText: JSON.stringify(preparedData, null, 4),
    };
    apiPostData(postPath, completedData);
};

// Dodano privremeno zbog #59779, obrisati kasnije.
export const reportOnlyStartDateSelected = () => {
    if (isBot(window.navigator.userAgent)) return;
    try {
        if (typeof zaraz !== 'undefined' && zaraz.consent) {
            const marketing = zaraz.consent.get('KlIi');
            if (marketing) {
                if (zaraz.track) {
                    zaraz.track('QuickSearchStartDateOnlySelected');
                }
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'QuickSearchStartDateOnlySelected',
                });
            }
        }
    } catch (err) {
        reportError(err);
    }
};

export const reportPageLeaveFrameHTMLElement = () => {
    if (isBot(window.navigator.userAgent)) return;
    const ref = document.referrer;
    if (!ref || ref.startsWith(ADRIATIC_PARTNER_RESPONSIVE_SCHEME_HOST)
        || ref.startsWith(ADRIATIC_RESPONSIVE_SCHEME_HOST)) {
        return;
    }
    try {
        const url = new URL(window.location.href);
        const fsSet = url.searchParams.get('fs_set');
        const endpointURL = `${window.origin}/rsb-service/log/warning${fsSet ? `?fs_set=${fsSet}` : ''}`;
        const data = {
            message: 'FRAME servis izašao iz partnerskog okvira. Provjeriti o čemu se radi.',
            errorOnPage: encodeURI(window.location.href) || 'Nepoznato',
            referrerPageToPageOnWhichErrorOcured: encodeURI(ref) || 'Nepoznato',
            timestamp: new Date().toLocaleString('en-GB', { timeZone: 'Europe/Zagreb' }),
            browserInfo: {
                userAgent: window.navigator.userAgent,
                language: window.navigator.language,
                platform: window.navigator.platform,
                cookiesEnabled: window.navigator.cookieEnabled,
                online: window.navigator.onLine,
                screenResolution: `${window.screen.width}x${window.screen.height}`,
                colorDepth: window.screen.colorDepth,
            },
        };
        const blob = new Blob([JSON.stringify({ logText: JSON.stringify(data) })], {
            type: 'application/json',
        });
        navigator.sendBeacon(endpointURL, blob);
    } catch (err) {
        reportError(err);
    }
};
